import {match} from 'ts-pattern';

import {isNotNil} from 'ramda';

import {ListVehicleFinancingTemplateResponseBody} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

export function getVehicleFinancingTemplateValidityLabel(
  template: Pick<ListVehicleFinancingTemplateResponseBody, 'archived' | 'validFrom' | 'validTo'>,
  formatDate: (date: Date) => string
): string {
  const validFrom = parseDate(template.validFrom);
  const validTo = parseDate(template.validTo);
  const formattedValidFrom = isNotNil(validFrom) ? formatDate(validFrom) : '';
  const formattedValidTo = isNotNil(validTo) ? formatDate(validTo) : '';

  return match({
    archived: template.archived,
    hasValidFrom: isNotNil(validFrom),
    hasValidTo: isNotNil(validTo),
  })
    .with({archived: false, hasValidFrom: false, hasValidTo: false}, () =>
      i18n.t('entity.vehicleFinancingTemplate.labels.validUnlimited')
    )
    .with({archived: true, hasValidFrom: false, hasValidTo: false}, () =>
      i18n.t('entity.vehicleFinancingTemplate.labels.wasValidUnlimited')
    )
    .with({archived: false, hasValidFrom: true, hasValidTo: false}, () =>
      i18n.t('entity.vehicleFinancingTemplate.labels.validFromOnly', {
        validFrom: formattedValidFrom,
      })
    )
    .with({archived: true, hasValidFrom: true, hasValidTo: false}, () =>
      i18n.t('entity.vehicleFinancingTemplate.labels.wasValidFromOnly', {
        validFrom: formattedValidFrom,
      })
    )
    .with({archived: false, hasValidFrom: false, hasValidTo: true}, () =>
      i18n.t('entity.vehicleFinancingTemplate.labels.validToOnly', {validTo: formattedValidTo})
    )
    .with({archived: true, hasValidFrom: false, hasValidTo: true}, () =>
      i18n.t('entity.vehicleFinancingTemplate.labels.wasValidToOnly', {
        validTo: formattedValidTo,
      })
    )
    .with({archived: false, hasValidFrom: true, hasValidTo: true}, () =>
      i18n.t('entity.vehicleFinancingTemplate.labels.validRange', {
        validFrom: formattedValidFrom,
        validTo: formattedValidTo,
      })
    )
    .with({archived: true, hasValidFrom: true, hasValidTo: true}, () =>
      i18n.t('entity.vehicleFinancingTemplate.labels.wasValidRange', {
        validFrom: formattedValidFrom,
        validTo: formattedValidTo,
      })
    )
    .exhaustive();
}
